import styled from "@emotion/styled";

const SubItemsWithIcon = styled.div`
    display: flex;
    column-gap: 10px;
`;
const SubItems = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 1.2rem;
`;

const SubItemHeadline = styled.div`
    font-weight: 600;
`;

const IconWrapper = styled.div`
    min-width: 25px;
    margin-right: 5px;
`;

const StyledDivs = {
    SubItemsWithIcon,
    SubItems,
    SubItemHeadline,
    IconWrapper,
};

export default StyledDivs;
